export default "__VITE_ASSET__DhNn6iD$__"